export var feeTypes = {
  MGR: {
    label: 'Comisión de gestión'
  },
  TER: {
    label: 'Ratio total de gastos'
  },
  RED: {
    label: 'Comisión de reembolso'
  },
  CUS: {
    label: 'Comisión de custodia'
  },
  SUC: {
    label: 'Comisión de éxito'
  },
  FLO: {
    label: 'Comisión de suscriptión'
  }
};